// extracted by css-extract-rspack-plugin
export default {"title":"title-R4Dk8G","text":"text-N30Gxb","nameRow":"nameRow-PXQ3lI","name":"name-pQ0OZR","badges":"badges-neovMN","emailRow":"emailRow-hCV2El","email":"email-XqUkWg"};